module.exports = __webpack_public_path__ + "img/advance7.9aa82641.png";